export const ITEM_CATEGORIES = [
  { en: "Spice Blends VRAC", fr: "Mélanges d'épices en VRAC" },
   { en: "Spice Blends Custom VRAC", fr: "Mélanges CLIENT VRAC" },
  { en: "Spices Bulk VRAC", fr: "Épices en VRAC" },
  // { en: "Spices Bulk VRAC", fr: "Épices en VRAC" },
  // { en: "Spices Bulk 2.5 KG", fr: "Épices VRAC 2.5KG" },
  // { en: "Spices Bulk 25 KG (MASTER)", fr: "Épices VRAC MASTER" },
  // { en: "Spices Bulk 5 KG", fr: "Épices VRAC 5KG" },
  // { en: "Spices Bulk 1 KG", fr: "Épices VRAC 1KG" },
  // { en: "Spices Bulk 10 KG", fr: "Épices VRAC 10KG" },
  // { en: "Spices Custom VRAC", fr: "Épices personnalisées VRAC" },
  // { en: "Spices Custom 25 KG (MASTER)", fr: "Épices CLIENT MASTER" },
  // { en: "Spices Custom 5 KG", fr: "Épices CLIENT 5KG" },

  // { en: "NutriVilla Bags 50g UN", fr: "Épices NV 50g UN" },
  // { en: "NutriVilla Bags 50g CS", fr: "Sacs NutriVilla 50g CS" },
  // { en: "NutriVilla Bags 50g MASTER", fr: "Sacs NutriVilla 50g MASTER" },

  // { en: "Yasmine Bags 100g UN", fr: "Épices Yasmine 100g UN" },
  // { en: "Yasmine Bags 100g CS", fr: "Épices Yasmine 100g CS" },

  // { en: "ASA Bottles: 14oz UN", fr: "Épices ASA 14oz UN" },
  // { en: "ASA Bottles: 14oz CS", fr: "Épices ASA 14oz CS" },
  // { en: "ASA Bottles: 29oz UN", fr: "Épices ASA 29oz UN" },
  // { en: "ASA Bottles: 29oz CS", fr: "Épices ASA 29oz CS" },

  // { en: "A Spice Affair UN CA", fr: "Épices ASA UN CA" },
  // { en: "A Spice Affair UN US", fr: "Épices ASA UN US" },
  // { en: "A Spice Affair UN MX", fr: "Épices ASA UN MX" },
  // { en: "A Spice Affair UN MENA", fr: "A Spice Affair UN MENA" },
  // { en: "A Spice Affair UN EU", fr: "A Spice Affair UN EU" },
  // { en: "A Spice Affair 6-CS", fr: "Épices ASA 6-CS" },
  // { en: "A Spice Affair 12-CS", fr: "Épices ASA 12-CS" },

  // { en: "ASA 3-Packs UN", fr: "Assortiment ASA PQT-3 UN" },
  // { en: "PDE 4-Pack UN", fr: "PDE Pack de 4 UN" },
  // { en: "PDE 4-Pack CS", fr: "PDE Pack de 4 CS" },

  // { en: "ASA Variety Packs 4-PK", fr: "Assortiment ASA 4-CS" },
  // { en: "ASA Variety Packs 6-PK", fr: "Assortiment ASA 6-CS" },
  // { en: "ASA Variety Packs 12-PK", fr: "Assortiment ASA 12-CS" },

  // { en: "Passion d'épices UN", fr: "Passion d'épices UN" },
  // { en: "Passion d'épices 12-CS", fr: "Passion d'épices 12-CS" },

  // { en: "ASA Grinders UN", fr: "ASA Moulins UN" },
  // { en: "ASA Grinders Set", fr: "ASA Ensemble de moulins" },

  // { en: "Tea Bulk VRAC", fr: "Thé en VRAC" },
  // { en: "ASA: Large Pouch", fr: "ASA : Grands sacs" },

  // { en: "Co-Branded: Chef Deema Pouches", fr: "Co-Marque : Chef Deema Poches" },
  // { en: "Co-Branded: Chef Deema Signature", fr: "Co-Marque : Chef Deema Signature" },
  // { en: "Co-Branded: Chef Deema Shakers", fr: "Co-Marque : Chef Deema Shakers" },

  // { en: "Co-Branded: Chef Island Gurl Signature", fr: "Co-marque : Chef Island Gurl Signature" },
  // { en: "Co-Branded: Chef Island Gurl Pouches", fr: "Co-marque : Chef Island Gurl Poches" },
  // { en: "Co-Branded: Chef Island Gurl Shakers", fr: "Co-Marque : Chef Island Gurl Shakers" },

  // { en: "Co-Branded: Chef Amine Signature", fr: "Co-marquage : Signature Chef Amine" },

  // { en: "Private Label: Spice Age Small Pouch", fr: "Marque privée : Petit sachet Spice Age" },
  // { en: "Private Label: Youngevity Pouches", fr: "Marque privée : Youngevity Poches" },
  // { en: "Private Label: Baker PL-6", fr: "Marque privée : Baker PL-6" },
  // { en: "Private Label: Baker Large Shaker", fr: "Marque privée : Grand shaker Baker" },

  // { en: "Displays", fr: "Présentoirs" },
];